import React, { useEffect } from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import SmoothScroll from "./components/SmoothScroll";
import Scrollbar from "./components/ScrollBar";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import { hydrate } from "react-dom";
import { createRoot } from "react-dom/client";
import { FixingProvider } from "./context/FixingGoldContext";
import TagManager from "react-gtm-module";
import { BrowserRouter } from "react-router-dom";
import FixingGold from "./components/FixingGold";
import NavbarNew from "./components/NavbarNew";
import Footer from "./components/Footer";
import RouteFocusHandler from "./components/RouteFocusHandler";
import NavbarPill from "./components/NavbarPill";

const tagManagerArgs = {
  gtmId: "GTM-5VBL7N7",
};

const disableGTM = false;

const GtmInit = () => {
  useEffect(() => {
    if (window.location.hostname !== "localhost" && !disableGTM) {
      TagManager.initialize(tagManagerArgs);
    }
  }, []);
};

AOS.init();

const SkipToContent = () => {
  const handleSkip = (e) => {
    e.preventDefault();

    const main = document.getElementById("main-content");
    // if (!main) return;

    main.focus({ preventScroll: true });
    main.scrollIntoView({
      behavior: "auto",
      block: "start",
    });
  };
  return (
    <a
      href="#main-content"
      onClick={handleSkip}
      className="
        sr-only
        focus:not-sr-only
        focus:fixed
        focus:top-4
        focus:left-4
        focus:z-[9999]
        focus:px-4
        focus:py-2
        focus:bg-black
        focus:text-white
        focus:rounded-md
        focus:outline-none
        focus:ring-2
        focus:ring-white
      "
    >
      Vai al contenuto principale
    </a>
  );
};


const isDesktop = () => window.innerWidth >= 768;

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);


root.render(
  <React.StrictMode>
    <FixingProvider>
      <BrowserRouter>
        <SkipToContent />

        {isDesktop() && (
          <>
            <Scrollbar />
            <SmoothScroll />
          </>
        )}

        {/* <NavbarPill /> */}

        <main id="main-content" tabIndex={-1}>
          <App />
        </main>

        {/* <Footer /> */}
        {/* <FixingGold /> */}
        <RouteFocusHandler />
        <GtmInit />
      </BrowserRouter>
    </FixingProvider>
  </React.StrictMode>
);

reportWebVitals();
